<template>
  <div class="home">
    <home-welcome-sec></home-welcome-sec>

    <home-base-list-sec class="d-none d-md-block"></home-base-list-sec>
    <home-base-list-mob-sec class="d-block d-md-none"></home-base-list-mob-sec>
    <home-news-list-sec></home-news-list-sec>
    <home-services-sec></home-services-sec>
    <home-counter-sec></home-counter-sec>
  </div>
</template>

<script>
// @ is an alias to /src

import HomeWelcomeSec from "@/components/HomeWelcomeSec.vue";
import HomeBaseListSec from "@/components/HomeBaseListSec.vue";
import HomeBaseListMobSec from "@/components/HomeBaseListMobSec.vue";
import HomeNewsListSec from "@/components/HomeNewsListSec.vue";
import HomeServicesSec from "@/components/HomeServicesSec.vue";
import HomeCounterSec from "@/components/HomeCounterSec.vue";

export default {
  name: "home",
  data() {
    return {
      baseApiUrl: window.env.VUE_APP_API_URL_PRODUCTION,

      meta: {
        title: "Правно-информациони систем РС",
        description:
          "Правно-информациони систем je збирка података у електронском облику која садржи: електронски облик Службеног гласника, архиву службених гласила, базу која садржи регистар и текстове важећих прописа и других аката Републике Србије објављених у Службеном гласнику, базу која садржи судску праксу, друге податке о правном систему Републике Србије и везу с правним актима Европске уније.",
        keywords:
          "zakoni, akti, zakonski, propisi, sudska praksa, registar, odluka, sudovi, ugovori, pravno informacioni sistem, prins, pis,sluzbeni glasnik",
      },
    };
  },
  components: {
    // HelloWorld,
    HomeWelcomeSec,
    HomeBaseListSec,
    HomeBaseListMobSec,
    HomeNewsListSec,
    HomeServicesSec,
    HomeCounterSec,
  },
  metaInfo() {
    return {
      title: this.meta.title,
      meta: [
        { name: "title", content: this.meta.title },
        { name: "description", content: this.meta.description },
        { name: "keywords", content: this.meta.keywords },
      ],
    };
  },
  mounted() {
    document.querySelector(".date_111");
    if (this.$route.query.promo !== undefined) {
      this.$bvToast.toast(
        "Успешно сте се регистровали. Информације о приступу су Вам послате на емаил.",
        {
          title: "Glasnik",
          variant: "success",
        }
      );
    }
  },

  beforeCreate: function() {
    document.body.className = "color_standard home-page";
  },
};
</script>
<style>
.main {
  background-color: #ddd !important;
  padding-bottom: 360px !important;
}
</style>
